export default __webpack_public_path__ + "static/media/antipollution.0052f80d.jpg";